<template>
  <nav class="mega-menu">
    <div class="mega-menu__aside">
      <div class="mega-menu__link-group">
        <div
          class="mega-menu__aside-link"
          :class="isLearningAreasActive ? 'active' : ''"
          @mouseenter="openLearningAreas()"
        >
          Learning Areas
          <span class="mega-menu__aside-link-arrow material-icons"
            >keyboard_arrow_right</span
          >
        </div>
        <div @mouseenter="closeLearningAreas()">
          <router-link
            :to="{ name: 'learning-paths' }"
            @click.native="$emit('closeMegaMenu')"
            class="mega-menu__aside-link"
            >Learning Paths</router-link
          >
        </div>
      </div>
    </div>
    <Categories
      v-if="isLearningAreasVisible"
      @mouseenter="openLearningAreas()"
      @closeMegaMenu="$emit('closeMegaMenu')"
      @openLearningAreas="openLearningAreas"
      :class="isLearningAreasActive ? 'mega-menu__categories--active' : ''"
      :isLearningAreasActive="isLearningAreasActive"
      :openCategorySearch="openCategorySearch"
      :getCategoryDetails="getCategoryDetails"
      :categories="categories"
      class="mega-menu__categories"
    />
  </nav>
</template>

<script>
import Categories from './Categories.vue'

export default {
  name: 'DesktopMegaMenu',
  props: {
    categories: {
      type: Array,
      required: true,
    },
    getCategoryDetails: {
      type: Function,
      required: true,
    },
    openCategorySearch: {
      type: Function,
      required: true,
    },
  },
  components: {
    Categories,
  },
  data() {
    return {
      isLearningAreasActive: false,
      isLearningAreasVisible: true,
    }
  },
  methods: {
    openLearningAreas() {
      this.isLearningAreasActive = true
      this.isLearningAreasVisible = true
    },
    closeLearningAreas() {
      this.isLearningAreasActive = false
      this.isLearningAreasVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
$mobile: 320px;
$tablet: 769px;
$desktop: 1024px;
$lg_desktop: 1300px;
.mega-menu {
  $this: &;
  display: none;
  @media screen and (min-width: $tablet) {
    position: absolute;
    top: 96%;
    right: 32px;
    left: 32px;
    height: 500px;
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
  }
  &__aside {
    flex-grow: 0;
    flex-shrink: 0;
    width: 292px;
    flex-basis: 292px;
    background: var(--dark-gray);
  }
  &__link-group {
    margin: 20px 0 40px 0;
    padding: 0;
    list-style-type: none;
    &:last-child {
      margin: 0;
    }
  }
  &__aside-link-arrow {
    position: absolute;
    display: block;
    opacity: 0;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    color: var(--white);
    transition: all 0.2s ease-out;
    font-size: (20 / 16) * 1rem;
  }
  &__aside-link {
    padding: 16px 20px 16px 60px;
    position: relative;
    background: var(--dark-gray);
    font-size: (18 / 16) * 1rem;
    color: var(--white);
    display: block;
    cursor: pointer;
    &:before {
      content: '';
      display: block;
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 8px;
      background: var(--orange);
      transition: all 0.2s ease-out;
    }
    &:hover,
    &.active {
      background: #222;
      &:before,
      #{$this}__aside-link-arrow {
        opacity: 1;
      }
    }
  }
}
</style>
